<template>
    <v-lazy v-model="lazy" :options="{ rootMargin: '250px', threshold: 0.5 }" min-height="160">
        <v-card class="photo-face-card" style="display: flex; width: 100%;">
            <v-container class="ma-0 pa-1" style="width: 50%;">
                <v-row dense class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0 text-center">
                        <span style="font-size: 10px;">{{ face.no }}</span>
                    </v-col>
                    <v-tooltip v-if="editIcon" bottom>
                        <template #activator="{ on }">
                            <v-btn icon x-small :style="{ position: 'absolute', left: '0' }" v-on="on"
                                @click="$emit('edit-icon-clicked')">
                                <v-icon>mdi-account-edit</v-icon>
                            </v-btn>
                        </template>
                        <span>顔マスタを修正する</span>
                    </v-tooltip>
                </v-row>
                <v-row class="ma-0 pa-0">
                    <v-col v-if="!rerendering" cols="12" class="ma-0 pa-0 flex-center">
                        <v-tooltip bottom>
                            <template #activator="{ }">
                                <v-img :src="imageSrc" contain :width="80" :height="80"
                                    :class="isHighlighting ? 'highlighting' : ''" @click="clickFaceImage" />
                            </template>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row v-if="!!face.student_no" dense class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0 text-center">
                        <span style="font-size: 10px;">{{ face.class }}{{ face.student_no }}</span>
                    </v-col>
                    <v-tooltip v-if="deleteIcon" bottom>
                        <template #activator="{ on }">
                            <v-btn icon x-small :style="{ position: 'absolute', left: '0' }" v-on="on"
                                @click="$emit('delete-icon-clicked')">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>検出顔の削除</span>
                    </v-tooltip>
                </v-row>
                <v-row>
                    <v-col cols="4">

                    </v-col>
                </v-row>
            </v-container>
            <v-container style="display: flex; flex-direction: column; align-items: center; padding: 4px; width: 50%;">
                <!-- アルバム全体頻度表示部 -->
                <v-row style="width: 100%; height: 16px;" justify="space-between">
                    <v-col cols="6" class="ma-0 pa-0">
                        <div style="height: 20px; display: flex; align-items: center;">
                            <img style="height: 11px; width: 11px; margin-right: 2px;" src="/images/ri_camera-fill.png" />
                            <span style="font-size: 10px !important;">
                                {{ frequency.shooting_student_frequency }}
                            </span>
                        </div>
                    </v-col>
                    <v-col cols="6" class="ma-0 pa-0" style="display: flex; justify-content: flex-end;">
                        <div style="height: 20px; display: flex; align-items: center;">
                            <img style="height: 9px; width: 10px; margin-right: 2px;" src="/images/Vector.png" />
                            <span style="color: #FC81A4; font-size: 10px !important;">
                                {{ frequency.frequency_of_whole_album }}
                            </span>
                        </div>
                    </v-col>
                </v-row>
                <!-- 顔画像表示部 -->
                <v-row class="ma-0 pa-0" style="width: 100%;">
                    <v-col v-if="!rerendering" class="text-center pa-1">
                        <v-img v-if="!rerendering" :src="frequency.face_image_path" contain height="80" max-width="95"
                            style="cursor: pointer;" :class="isUnselectedFace ? 'unselectedFace' : ''"
                            @click="clickFaceImage" />
                    </v-col>
                </v-row>
                <!-- 撮影行事内頻度表示部 -->
                <v-row class="ma-0 pa-0" style="width: 100%;">
                    <v-col cols="6" class="ma-0 pa-0">
                        <div
                            style="border: 2px solid #FF8B00; border-radius: 8px; background-color: #FF8B00; width: 27px; height: 13px; display: flex; justify-content: center; align-items: center;">
                            <img style="height: 7px; width: 9px; margin-right: 2px;" src="/images/ooui_hand.png" />
                            <span style="color: #FFFFFF; font-size: 10px;">
                                {{ frequency.student_selected_frequency }}
                            </span>
                        </div>
                    </v-col>
                    <v-col cols="6" class="ma-0 pa-0" style="display: flex; justify-content: flex-end;">
                        <div v-if="frequency.student_auto_selected_frequency != 0"
                            style="border: 2px solid #0F68B1; border-radius: 8px; background-color: #0F68B1; width: 27px; height: 13px; display: flex; justify-content: center; align-items: center;">
                            <span style="color: #FFFFFF; font-size: 10px;">+</span>
                            <span style="color: #FFFFFF; font-size: 10px;">
                                {{ frequency.student_auto_selected_frequency }}
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-lazy>
</template>

<script>
import monet from 'monet';

export default {
    props: {
        id: {
            default: 0,
        }, // face_id or photo_face_id.
        frequency: {
            type: Object,
            default: undefined,
        },
        face: {
            type: Object,
            default: undefined,
        },
        imageSrc: {
            type: String,
            default: '',
        },
        laughingRate: {
            type: [String, Number],
            default: undefined,
        },
        isHighlighting: {
            type: Boolean,
            default: false,
        },
        clickCallback: {
            type: Function,
            default: x => { },
        },
        faceWidth: {
            type: Number,
            default: 80,
        },
        faceHeight: {
            type: Number,
            default: 80,
        },
        editIcon: {
            type: Boolean,
            default: false,
        },
        deleteIcon: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            lazy: false,
            rerendering: false,
        };
    },
    methods: {
        clickFaceImage() {
            this.clickCallback(this.id);
            this.rerender(); // 強制的に再描画
        },
        rerender() {
            this.rerendering = true;
            this.$nextTick(() => this.rerendering = false);
        },
    },
};
</script>

<style>
div.v-image.highlighting {
    border: solid 2px #FFFFFF;
}
</style>
